import { createAsyncThunk } from '@reduxjs/toolkit'
import { Salutation, User } from '../../@types/user'
import { getUserInfo } from '../../clients/userInfoClient'

const fetchUserInfo = createAsyncThunk<Partial<User>, undefined, Record<string, unknown>>(
  'user/fetchUserInfo',
  async () => {
    const { email, salutation, firstname, lastname, phoneNumber } = await getUserInfo()
    const payload: Partial<User> = {}
    if (email) {
      payload['email'] = email
    }

    if (salutation) {
      payload['salutation'] = salutation === 'MALE' ? Salutation.HERR : Salutation.FRAU
    }

    if (firstname) {
      payload['firstName'] = firstname
    }

    if (lastname) {
      payload['lastName'] = lastname
    }

    if (phoneNumber) {
      payload['phoneNumber'] = phoneNumber
    }

    return payload
  }
)

export { fetchUserInfo }
